const {
  createStyledBreakpoints,
  createTheme,
} = require('./styled-breakpoints');

exports.createStyledBreakpoints = createStyledBreakpoints;
exports.createTheme = createTheme;
